import Button from "./Button.jsx";
import {columnSorter} from "../../libs.jsx";
import {toast} from "react-toastify";
import {useState, useEffect, useRef} from "react";

const TableHeaders = (props) => {
    let returnData = [], row;
    let rows = [];
    let styles = {};

    const [activeDropdown, setActiveDropdown] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = (column) => {
        setActiveDropdown(activeDropdown === column ? null : column);
    };

    const getFilterKey = (headerDataItem) => {
        return headerDataItem?.filterKey || headerDataItem?.key;
    };

    const getSortKey = (headerDataItem) => {
        return headerDataItem?.sortKey || headerDataItem?.key;
    };

    const getUniqueValues = (headerDataItem) => {
        const originalKey = headerDataItem?.key;
        const filterKey = headerDataItem?.filterKey;
        const values = [];

        props.originData.forEach(item => {
            const value = item?.[originalKey];
            const altValue = item?.[filterKey]
            if (Array.isArray(value)) {
                // Handle array values
                if (value.length <= 0){
                    values.push("");
                }else {
                    value.forEach(arrayItem => {
                        if (arrayItem && typeof arrayItem === 'object') {
                            // If it's an object and we have a filterKey, extract the filterKey value
                            const extractedValue = arrayItem[filterKey];
                            if (extractedValue !== null && extractedValue !== undefined) {
                                values.push(String(extractedValue));
                            }else{
                                values.push("");
                            }
                        } else {
                            // If it's a primitive value in the array, use it directly
                            if (arrayItem !== null && arrayItem !== undefined) {
                                values.push(String(arrayItem));
                            }else{
                                values.push("");
                            }
                        }
                    });
                }
            } else {
                if (headerDataItem?.filterKey){
                    if (altValue !== null && altValue !== undefined) {
                        values.push(String(altValue));
                    }else{
                        values.push("");
                    }
                }else{
                    if (value !== null && value !== undefined) {
                        values.push(String(value));
                    }else{
                        values.push("");
                    }
                }
            }
        });

        return [...new Set(values)].sort((a, b) =>
            a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'})
        );
    };

    const hasActiveFilters = (columnKey) => {
        return props?.headerFilters?.[columnKey]?.length > 0;
    };

    const handleCheckboxChange = (column, value) => {
        props.setHeaderFilters(prev => {
            const currentFilters = prev[column] || [];
            const newFilters = currentFilters.includes(value)
                ? currentFilters.filter(v => v !== value)
                : [...currentFilters, value];

            return {
                ...prev,
                [column]: newFilters
            };
        });
        props?.setPage(1);
    };

    const clearFilters = (columnKey) => {
        props.setHeaderFilters(prev => ({
            ...prev,
            [columnKey]: []
        }));
    };

    let rowCnt = props?.rowCnt ? props.rowCnt : 1;
    for (let i2=0; i2 < rowCnt; i2++){
        returnData = [];
        if (i2 === 0){
            if (props?.checkbox){
                returnData.push(
                    <th className={"table table-header py-0 border-top-0"} style={{width: "24px"}} key={"header-box"} rowSpan={rowCnt}>
                        <div className={"form-check"} style={{maxWidth: "24px"}}
                             onClick={() => props?.writeAccess ? {} : toast.warn("Edit privileges are disabled.")}
                             title={props?.writeAccess ? "" : "Not authorized to make changes"}>
                            {props?.writeAccess
                                ? <input className={"form-check-input table-checkbox"} defaultChecked={false} type={"checkbox"}
                                         id={props?.checkboxHeaderId ? props.checkboxHeaderId : "uCheckHead"}
                                   onChange={() => {
                                       props?.checkAll();
                                       props?.actionAppearance();
                                   }} />
                                : <input className={"form-check-input table-checkbox"} type={"checkbox"}
                                         id={props?.checkboxHeaderId ? props.checkboxHeaderId : "uCheckHead"} disabled={true} />}
                            <label className={"form-check-label"} htmlFor={props?.checkboxHeaderId ? props.checkboxHeaderId : "uCheckHead"}> </label>
                        </div>
                    </th>
                );
            }else if (props?.radio){
                returnData.push(
                    <th className={"table table-header py-0 border-top-0 text-start fw-normal text-center"}
                        style={{width: "70px"}} key={"header-edit-box"} rowSpan={rowCnt}>
                        {props?.radio_name ? props.radio_name : ""}
                    </th>
                );
            }
            if (props?.modal){
                returnData.push(
                    <th className={"table table-header py-0 border-top-0 text-start fw-normal text-center"}
                        style={{width: "55px"}} key={"header-edit-box"} rowSpan={rowCnt}>
                        {props?.modal_name ? props.modal_name : ""}
                    </th>
                );
            }
            if (props?.actionIcon){
                returnData.push(
                    <th className={"table table-header py-0 border-top-0 text-start fw-normal text-center"}
                        style={{width: "55px"}}
                        key={"header-action-box"} rowSpan={rowCnt}>
                        {props?.action_name ? props.action_name : ""}
                    </th>
                );
            }
        }
        for (let i=0; i < props?.headerData?.length; i++){
            if (props?.headerData[i]?.style){
                styles = {...props.headerData[i].style};
            }else{
                styles = {};
            }
            if (props?.headerData[i]?.borderLeft){
                styles["borderLeftColor"] = props?.headerData[i]?.bgColor ? props.headerData[i].bgColor : "#0081C7";
                styles["borderLeftWidth"] = "6px";
            }
            styles["backgroundColor"] = props?.headerData[i]?.bgColor ? props.headerData[i].bgColor : "#0081C7"
            row = props?.headerData[i]?.row ? props.headerData[i].row : 1;
            if (i2+1 === row){
                if (props?.headerData[i]?.rowSpan){
                    if (props?.headerData[i]?.sorts === false){
                        if (props?.headerFiltersOn && props?.headerData[i]?.filtered){
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`} rowSpan={props?.headerData[i]?.rows}
                                    style={styles}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"}
                                            id={`${props?.checkboxHeaderId}-${i}`}
                                            style={{cursor: "unset", pointerEvents: "none"}}/>
                                    <button className={"btn btn-link hover-text-white p-2"} type={"button"}
                                            style={{color: hasActiveFilters(getFilterKey(props.headerData[i])) ? "#ffa500" : "lightgrey"}}
                                            onClick={() => toggleDropdown(props.headerData[i].label)}>
                                        <i className={"fe fe-filter as-btn-1x"}></i>
                                    </button>
                                    {
                                        activeDropdown === props.headerData[i].label &&
                                        (
                                            <div className={"dropdown-menu show p-2"}
                                                 ref={dropdownRef}
                                                 style={{minWidth: '200px', maxHeight: "calc(40vh)", overflowY: "auto"}}>
                                                <div className={"mt-2 mb-1"}>
                                                    <small className={"text-muted"}>Filter by {props.headerData[i].label}</small>
                                                    <button type={"button"} className={"btn btn-link"}
                                                            onClick={() => clearFilters(getFilterKey(props.headerData[i]))}>
                                                        Clear
                                                    </button>
                                                </div>
                                                {getUniqueValues(props.headerData[i]).map((value) => (
                                                    <div key={value} className={"form-check d-block"}>
                                                        <input type={"checkbox"} className={"m-0 align-middle"} style={{width: "13px", height: "13px"}}
                                                               id={`${props.headerData[i].label}-${value}`}
                                                               checked={(props?.headerFilters[getFilterKey(props.headerData[i])] || []).includes(value)}
                                                               onChange={() => handleCheckboxChange(getFilterKey(props.headerData[i]), value)} />
                                                        <label className={"form-check-label fw-normal fs-5 p-0 ms-3 my-1"}
                                                               htmlFor={`${props.headerData[i].label}-${value}`}>
                                                            {value}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </th>
                            );
                        } else {
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`} rowSpan={props?.headerData[i]?.rows}
                                    style={styles}>
                                <Button text={props.headerData[i].label} class={"btn btn-header"} id={`${props?.checkboxHeaderId}-${i}`}
                                            style={{cursor: "unset", pointerEvents: "none"}}/>
                                </th>
                            );
                        }
                    }else{
                        if (props?.headerFiltersOn && props?.headerData[i]?.filtered){
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`} key={`header-${props?.checkboxHeaderId}-${i}`}
                                    style={styles} rowSpan={props?.headerData[i]?.rows}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"} icon={props?.sortColumn === getSortKey(props.headerData[i])}
                                            iconClass={props?.sortOrder === "desc" ? "fe fe-chevron-down" : "fe fe-chevron-up"} id={`${props?.checkboxHeaderId}-${i}`}
                                            onClick={() => columnSorter(getSortKey(props.headerData[i]), props?.sorter, props?.setSorter)} />
                                    <button className={"btn btn-link hover-text-white p-2"} type={"button"}
                                            style={{color: hasActiveFilters(getFilterKey(props.headerData[i])) ? "#ffa500" : "lightgrey"}}
                                            onClick={() => toggleDropdown(props.headerData[i].label)}>
                                        <i className={"fe fe-filter as-btn-1x"}></i>
                                    </button>
                                    {
                                        activeDropdown === props.headerData[i].label &&
                                        (
                                            <div className={"dropdown-menu show p-2"}
                                                 ref={dropdownRef}
                                                 style={{minWidth: '200px', maxHeight: "calc(40vh)", overflowY: "auto"}}>
                                                <div className={"mt-2 mb-1"}>
                                                    <small className={"text-muted"}>Filter by {props.headerData[i].label}</small>
                                                    <button className={"btn btn-link"} type={"button"}
                                                            onClick={() => clearFilters(getFilterKey(props.headerData[i]))}>
                                                        Clear
                                                    </button>
                                                </div>
                                                {getUniqueValues(props.headerData[i]).map((value) => (
                                                    <div key={value} className={"form-check d-block"}>
                                                        <input type={"checkbox"} className={"m-0 align-middle"} style={{width: "13px", height: "13px"}}
                                                               id={`${props.headerData[i].label}-${value}`}
                                                               checked={(props?.headerFilters[getFilterKey(props.headerData[i])] || []).includes(value)}
                                                               onChange={() => handleCheckboxChange(getFilterKey(props.headerData[i]), value)} />
                                                        <label className={"form-check-label fw-normal fs-5 p-0 ms-3 my-1"}
                                                               htmlFor={`${props.headerData[i].label}-${value}`}>
                                                            {value}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </th>
                            );
                        } else {
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`} rowSpan={props?.headerData[i]?.rows} style={styles}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"} icon={props?.sortColumn === getSortKey(props.headerData[i])}
                                            iconClass={props?.sortOrder === "desc" ? "fe fe-chevron-down" : "fe fe-chevron-up"} id={`${props?.checkboxHeaderId}-${i}`}
                                            onClick={() => columnSorter(getSortKey(props.headerData[i]), props?.sorter, props?.setSorter)} />
                                </th>
                            );
                        }
                    }
                }else if (props?.headerData[i]?.colSpan){
                    returnData.push(
                        <th className={`table table-header w-auto py-0 border-top-0 border-bottom-0 px-1`}
                            key={`header-${props?.checkboxHeaderId}-${i}`}
                            colSpan={props?.headerData[i]?.cols}
                             style={styles}>
                            <Button text={props.headerData[i].label} class={"btn btn-header"}
                                    id={`${props?.checkboxHeaderId}-${i}`}
                                    style={{cursor: "unset", pointerEvents: "none"}}/>
                        </th>
                    );
                }else{
                    if (props?.headerData[i]?.sorts === false){
                        if (props?.headerFiltersOn && props?.headerData[i]?.filtered){
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`}
                                    style={styles}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"}
                                            id={`${props?.checkboxHeaderId}-${i}`}
                                            style={{cursor: "unset", pointerEvents: "none"}}/>
                                    <button className={"btn btn-link hover-text-white p-2"} type={"button"}
                                            style={{color: hasActiveFilters(getFilterKey(props.headerData[i])) ? "#ffa500" : "lightgrey"}}
                                            onClick={() => toggleDropdown(props.headerData[i].label)}>
                                        <i className={"fe fe-filter as-btn-1x"}></i>
                                    </button>
                                    {
                                        activeDropdown === props.headerData[i].label &&
                                        (
                                            <div className={"dropdown-menu show p-2"}
                                                 ref={dropdownRef}
                                                 style={{minWidth: '200px', maxHeight: "calc(40vh)", overflowY: "auto"}}>
                                                <div className={"mt-2 mb-1"}>
                                                    <small className={"text-muted"}>Filter by {props.headerData[i].label}</small>
                                                    <button className={"btn btn-link"} type={"button"}
                                                            onClick={() => clearFilters(getFilterKey(props.headerData[i]))}>
                                                        Clear
                                                    </button>
                                                </div>
                                                {getUniqueValues(props.headerData[i]).map((value) => (
                                                    <div key={value} className={"form-check d-block"}>
                                                        <input type={"checkbox"} className={"m-0 align-middle"} style={{width: "13px", height: "13px"}}
                                                               id={`${props.headerData[i].label}-${value}`}
                                                               checked={(props?.headerFilters[getFilterKey(props.headerData[i])] || []).includes(value)}
                                                               onChange={() => handleCheckboxChange(getFilterKey(props.headerData[i]), value)} />
                                                        <label className={"form-check-label fw-normal fs-5 p-0 ms-3 my-1"}
                                                               htmlFor={`${props.headerData[i].label}-${value}`}>
                                                            {value}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </th>
                            );
                        } else {
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`}
                                    style={styles}>
                                <Button text={props.headerData[i].label} class={"btn btn-header"} id={`${props?.checkboxHeaderId}-${i}`}
                                            style={{cursor: "unset", pointerEvents: "none"}}/>
                                </th>
                            );
                        }
                    }else{
                        if (props?.headerFiltersOn && props?.headerData[i]?.filtered){
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`} key={`header-${props?.checkboxHeaderId}-${i}`}
                                    style={styles}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"} icon={props?.sortColumn === getSortKey(props.headerData[i])}
                                            iconClass={props?.sortOrder === "desc" ? "fe fe-chevron-down" : "fe fe-chevron-up"} id={`${props?.checkboxHeaderId}-${i}`}
                                            onClick={() => columnSorter(getSortKey(props.headerData[i]), props?.sorter, props?.setSorter)} />
                                    <button className={"btn btn-link hover-text-white p-2"} type={"button"}
                                            style={{color: hasActiveFilters(getFilterKey(props.headerData[i])) ? "#ffa500" : "lightgrey"}}
                                            onClick={() => toggleDropdown(props.headerData[i].label)}>
                                        <i className={"fe fe-filter as-btn-1x"}></i>
                                    </button>
                                    {
                                        activeDropdown === props.headerData[i].label &&
                                        (
                                            <div className={"dropdown-menu show p-2"}
                                                 ref={dropdownRef}
                                                 style={{minWidth: '200px', maxHeight: "calc(40vh)", overflowY: "auto"}}>
                                                <div className={"mt-2 mb-1"}>
                                                    <small className={"text-muted"}>Filter by {props.headerData[i].label}</small>
                                                    <button className={"btn btn-link"} type={"button"}
                                                            onClick={() => clearFilters(getFilterKey(props.headerData[i]))}>
                                                        Clear
                                                    </button>
                                                </div>
                                                {getUniqueValues(props.headerData[i]).map((value) => (
                                                    <div key={value} className={"form-check d-block"}>
                                                        <input type={"checkbox"} className={"m-0 align-middle"} style={{width: "13px", height: "13px"}}
                                                               id={`${props.headerData[i].label}-${value}`}
                                                               checked={(props?.headerFilters[getFilterKey(props.headerData[i])] || []).includes(value)}
                                                               onChange={() => handleCheckboxChange(getFilterKey(props.headerData[i]), value)} />
                                                        <label className={"form-check-label fw-normal fs-5 p-0 ms-3 my-1"}
                                                               htmlFor={`${props.headerData[i].label}-${value}`}>
                                                            {value}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </th>
                            );
                        } else {
                            returnData.push(
                                <th className={`table table-header w-auto py-0 border-top-0 px-1`}
                                    key={`header-${props?.checkboxHeaderId}-${i}`}
                                    style={styles}>
                                    <Button text={props.headerData[i].label} class={"btn btn-header"}
                                            icon={props?.sortColumn === getSortKey(props.headerData[i])}
                                            iconClass={props?.sortOrder === "desc" ? "fe fe-chevron-down" : "fe fe-chevron-up"}
                                            id={`${props?.checkboxHeaderId}-${i}`}
                                            onClick={() => columnSorter(getSortKey(props.headerData[i]), props?.sorter, props?.setSorter)}/>
                                </th>
                            );
                        }
                    }
                }
            }
        }
        rows.push(
            <tr key={`header-row-${i2}`}>
                {returnData}
            </tr>
        )
    }

    return (
        <>{rows}</>
    )
};

export default TableHeaders;